import React from 'react';

const CustomCheckboxSVG = ({ fill }) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill={fill}
    >
      <rect width="20" height="20" rx="3" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.53033 14.2471L8 13.7168L7.46967 14.2471C7.76256 14.54 8.23744 14.54 8.53033 14.2471ZM8 12.6561L4.53033 9.18647C4.23744 8.89357 3.76256 8.89357 3.46967 9.18647C3.17678 9.47936 3.17678 9.95423 3.46967 10.2471L7.46967 14.2471L8 13.7168C8.53033 14.2471 8.53028 14.2472 8.53033 14.2471L16.2478 6.52961C16.5407 6.23672 16.5407 5.76184 16.2478 5.46895C15.955 5.17606 15.4801 5.17606 15.1872 5.46895L8 12.6561Z"
        fill="white"
      />
    </svg>
  );
};

export default CustomCheckboxSVG;
